import { Alert } from '@simplywallst/ui-core';

import { RouterLink } from '@redux-first-router-link';

import { ROUTE_PORTFOLIO_NEW } from '@/constants/routes';

export const YodleeDisconnectedState = () => {
  return (
    <div className="m-4 lg:mx-0">
      <Alert
        data-cy-id="alert-disconnected-message"
        styleType="warning"
        layout="stack"
      >
        <p className="m-0 text-sm">
          Your linked portfolio is now disconnected as we&apos;ve removed this
          linking provider (Yodlee). Here&apos;s what you can do:
        </p>
        <ul className="m-4 mr-16 list-disc space-y-2">
          <li>
            Reconnect your portfolio by checking if your broker is supported
            with a different provider from{' '}
            <RouterLink
              className="inline no-underline"
              to={{
                type: ROUTE_PORTFOLIO_NEW,
              }}
            >
              this page
            </RouterLink>{' '}
            (create a new portfolio and delete this one later).
          </li>
          <li>
            Duplicate this portfolio as a manual one using the settings button
            to continue tracking it, then delete the original.
          </li>
        </ul>
      </Alert>
    </div>
  );
};
